import { useBackend } from "../../services";

export const useGetAlbumProducts = () => {
  const { get } = useBackend();
  const getAlbumProducts = () => get("products/albums");
  return { getAlbumProducts };
};
